import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import React__default from 'react';
import { forwardRef, chakra } from '@chakra-ui/react';
import { mapResponsive, cx } from '@chakra-ui/utils';
import { createContext } from '@chakra-ui/react-utils';
var _excluded = ["className", "children", "spacing", "width", "w", "rowWidth", "rowW"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var _createContext = createContext({
    name: 'RowContext',
    errorMessage: 'useRowContext: `context` is undefined. Seems you forgot to wrap `<Col />` components in `<Row />`.'
  }),
  _createContext2 = _slicedToArray(_createContext, 2),
  RowProvider = _createContext2[0],
  useRowContext = _createContext2[1];

/**
 * Row
 *
 * A copy of the `Row` element of common CSS frameworks, used with `Col`.
 */
var Row = forwardRef(function (props, ref) {
  var className = props.className,
    children = props.children,
    _props$spacing = props.spacing,
    spacingProp = _props$spacing === void 0 ? 6 : _props$spacing,
    widthProp = props.width,
    wProp = props.w,
    rowWidthProp = props.rowWidth,
    rowWProp = props.rowW,
    rest = _objectWithoutProperties(props, _excluded);
  var styles = {
    display: 'flex',
    ml: mapResponsive(spacingProp, function (s) {
      if (typeof s === 'number') {
        return -Math.abs(s);
      }
      return "-".concat(s);
    }),
    flexWrap: 'wrap'
  };
  return /*#__PURE__*/React__default.createElement(chakra.div, _extends({
    className: cx("chakra-row", className),
    __css: _objectSpread(_objectSpread({}, styles), {}, {
      width: rowWidthProp,
      w: rowWProp
    })
  }, rest, {
    ref: ref
  }), /*#__PURE__*/React__default.createElement(RowProvider, {
    value: {
      spacing: spacingProp,
      width: widthProp || wProp
    }
  }, children));
});
export { Row, RowProvider, useRowContext };